import apiBaseUrl from '../../utils/config.js';

class AuthService {
    constructor() {
        this.baseUrl = `${apiBaseUrl}/auth`;
    }

    // 🔐 Login
    async login(loginRequest) {
        const response = await fetch(`${this.baseUrl}/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(loginRequest)
        });

        if (!response.ok) {
            throw new Error(await response.text());
        }

        const result = await response.json();
        localStorage.setItem("jwt", result.token);
        localStorage.setItem("username", result.username);
        return result;
    }

    // 🔐 Register new user (admin use only)
    async register(username, password, role) {
        const response = await fetch(`${this.baseUrl}/register`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username, password, role })
        });

        if (!response.ok) {
            throw new Error(await response.text());
        }

        return await response.json();
    }

    // ✅ Delete a user
    async deleteUser(username) {
        const token = this.getToken();
        const response = await fetch(`${this.baseUrl}/delete/${username}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${token}` }
        });

        if (!response.ok) {
            throw new Error(await response.text());
        }

        return await response.json();
    }

    // ✅ Edit user credentials
    async editUser(username, newPassword, newRole) {
        const token = this.getToken();
        const response = await fetch(`${this.baseUrl}/edit`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ username, newPassword, newRole })
        });

        if (!response.ok) {
            throw new Error(await response.text());
        }

        return await response.json();
    }

    // ✅ Get user role
    async getUserRole(username) {
        const token = this.getToken();
        const response = await fetch(`${this.baseUrl}/get-role/${username}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });

        if (!response.ok) {
            throw new Error(await response.text());
        }

        return await response.json();
    }

    // ✅ Check if logged in
    async checkAuthStatus() {
        const response = await fetch(`${this.baseUrl}/check-auth`, {
            credentials: 'include'
        });

        if (!response.ok) {
            return { authenticated: false };
        }

        return await response.json();
    }

    // ✅ JWT helpers
    getToken() {
        return localStorage.getItem("jwt");
    }

    getUsername() {
        return localStorage.getItem("username");
    }

    logout() {
        localStorage.removeItem("jwt");
        localStorage.removeItem("username");
    }

    // ✅ Generic request with auth
    async makeAuthRequest(endpoint, method = 'GET', body = null) {
        const token = this.getToken();
        const response = await fetch(`${this.baseUrl}${endpoint}`, {
            method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            ...(body && { body: JSON.stringify(body) })
        });

        if (!response.ok) {
            throw new Error(await response.text());
        }

        return await response.json();
    }
}

export default AuthService;
